import { Currency } from './CurrencyTypes'
/**
 * @deprecated use from @sparelabs/domain-logic instead
 */
export { RiderType, MatchingEndpoint } from '@sparelabs/domain-logic'

export { Language, LanguageLocaleMap, LocaleLanguageMap } from '@sparelabs/translate'

export interface IPrice {
  currency: Currency
  amount: number
}

export interface IEstimatedRange {
  minTs: number
  ts: number
  maxTs: number
}

export interface ITimeRange {
  startTs: number
  endTs: number
}

export enum UnitsOfDistance {
  Kilometer = 'km',
  Mile = 'mi',
}
